var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 361.8",
    style: {
      enableBackground: "new 0 0 1000 361.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:#016fd0}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-55.5 -1002.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3082",
    className: "st0",
    d: "M249.1 1364.2v-156.6H415l17.8 23.2 18.4-23.2H1053v145.8s-15.7 10.6-33.9 10.8H685.8l-20.1-24.7v24.7H600V1322s-9 5.9-28.4 5.9h-22.4v36.3h-99.5l-17.8-23.7-18 23.7H249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3080",
    className: "st0",
    d: "m55.5 1089.5 37.4-87.2h64.7l21.2 48.8v-48.8h80.4l12.6 35.3 12.2-35.3h360.9v17.7s19-17.7 50.1-17.7l117.1.4 20.9 48.2v-48.6h67.3l18.5 27.7v-27.7h67.9V1159h-67.9l-17.7-27.8v27.8h-98.8l-9.9-24.7h-26.6L756 1159h-67c-26.8 0-44-17.4-44-17.4v17.4H543.8l-20.1-24.7v24.7H148l-9.9-24.7h-26.5l-9.9 24.7H55.5v-69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    className: "st1",
    d: "M106.1 1021.7 55.7 1139h32.8l9.3-23.5h54.1l9.3 23.5h33.6l-50.4-117.3h-38.3zm18.7 27.2 16.5 41h-33l16.5-41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3048",
    className: "st1",
    d: "M198.2 1138.9v-117.3l46.7.2 27.1 75.6 26.5-75.8h46.3v117.3h-29.3v-86.4l-31.1 86.4h-25.7l-31.2-86.4v86.4h-29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    className: "st1",
    d: "M364.9 1138.9v-117.3h95.7v26.2h-66v20.1H459v24.7h-64.5v20.8h66v25.5h-95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3052",
    className: "st1",
    d: "M477.5 1021.7V1139h29.3v-41.7h12.3l35.2 41.7h35.8l-38.6-43.2c15.8-1.3 32.2-14.9 32.2-36 0-24.7-19.4-38-41-38l-65.2-.1zm29.3 26.2h33.5c8 0 13.9 6.3 13.9 12.3 0 7.8-7.6 12.3-13.5 12.3h-33.9v-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    className: "st1",
    d: "M625.6 1138.9h-29.9v-117.3h29.9v117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3056",
    className: "st1",
    d: "M696.6 1138.9h-6.5c-31.3 0-50.2-24.6-50.2-58.1 0-34.3 18.8-59.1 58.2-59.1h32.4v27.8H697c-16 0-27.4 12.5-27.4 31.6 0 22.7 13 32.2 31.6 32.2h7.7l-12.3 25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3058",
    className: "st1",
    d: "M760.4 1021.7 710 1138.9h32.8l9.3-23.5h54.1l9.3 23.5H849l-50.4-117.3-38.2.1zm18.6 27.2 16.5 41h-33l16.5-41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3060",
    className: "st1",
    d: "M852.4 1138.9v-117.3h37.3l47.6 73.7v-73.7h29.3v117.3h-36.1l-48.8-75.6v75.6h-29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3062",
    className: "st1",
    d: "M269.2 1344.1v-117.3h95.7v26.2h-66v20.1h64.5v24.7h-64.5v20.8h66v25.5h-95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3064",
    className: "st1",
    d: "M737.9 1344.1v-117.3h95.7v26.2h-66v20.1h64.2v24.7h-64.2v20.8h66v25.5h-95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    className: "st1",
    d: "m368.6 1344.1 46.6-57.9-47.7-59.4h36.9l28.4 36.7 28.5-36.7h35.5l-47.1 58.6 46.7 58.6h-36.9l-27.6-36.1L405 1344l-36.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3068",
    className: "st1",
    d: "M499.9 1226.9v117.3H530v-37h30.9c26.1 0 45.9-13.9 45.9-40.8 0-22.3-15.5-39.4-42.1-39.4h-64.8v-.1zm30.1 26.5h32.5c8.4 0 14.5 5.2 14.5 13.5 0 7.8-6 13.5-14.6 13.5H530v-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3072",
    className: "st1",
    d: "M619.4 1226.8v117.3h29.3v-41.7H661l35.2 41.7H732l-38.6-43.2c15.8-1.3 32.2-14.9 32.2-36 0-24.7-19.4-38-41-38l-65.2-.1zm29.4 26.3h33.5c8 0 13.9 6.3 13.9 12.3 0 7.8-7.6 12.3-13.5 12.3h-33.9v-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3074",
    className: "st1",
    d: "M847.2 1344.1v-25.5h58.7c8.7 0 12.4-4.7 12.4-9.8 0-4.9-3.7-9.9-12.4-9.9h-26.5c-23 0-35.9-14-35.9-35.1 0-18.8 11.8-36.9 46-36.9h57.1l-12.3 26.4h-49.4c-9.4 0-12.3 5-12.3 9.7 0 4.9 3.6 10.2 10.8 10.2h27.8c25.7 0 36.8 14.6 36.8 33.7 0 20.5-12.4 37.3-38.2 37.3h-62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3076",
    className: "st1",
    d: "M954.8 1344.1v-25.5h58.7c8.7 0 12.4-4.7 12.4-9.8 0-4.9-3.7-9.9-12.4-9.9H987c-23 0-35.9-14-35.9-35.1 0-18.8 11.8-36.9 46-36.9h57.1l-12.3 26.4h-49.4c-9.4 0-12.3 5-12.3 9.7 0 4.9 3.6 10.2 10.8 10.2h27.8c25.7 0 36.8 14.6 36.8 33.7 0 20.5-12.4 37.3-38.2 37.3h-62.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLogo);
export default __webpack_public_path__ + "static/media/amex-logo.7da73a167243127f0c2d9115a32daeba.svg";
export { ForwardRef as ReactComponent };